import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import Checkout from '../views/Checkout.vue'
import Cart from '../views/Cart.vue'
import Dashboard from '../views/Dashboard.vue'
import Campaigns from '../views/Campaigns.vue'
import Orders from '../views/Orders.vue'
import Product from '../views/Product.vue'
import Details from '../views/Details.vue'
import OrderDetails from '../views/OrderDetails.vue'
import BlockedDocuments from '../views/BlockedDocuments.vue'
import Profile from '../views/Profile.vue'
import Cards from '../views/Cards.vue'
import CallCenter from '../views/CallCenter.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import MySales from '../components/sales/MySales.vue'
import DetailsOrder from '../views/DetailsOrder.vue'
import RegisterClient from '../views/RegisterClient.vue'
import HistoricClient from '../views/HistoricClient.vue'
import OrdersOMS from '../views/OrdersOMS.vue'
import OrderPrint from '../views/OrderPrint.vue'
import Profitz from '../views/Profitz.vue'
import Redemptions from '../views/Redemptions.vue'
import Redeem from '../views/Redeem.vue'
import PendingBudgets from '../views/PendingBudgets.vue'
import PendingOrder from '../views/PendingOrder.vue'
import PendingPayment from '../views/PendingPayment.vue'
import PendingRisk from '../views/PendingRisk.vue'
import PartialOrder from '../views/PartialOrder.vue'
import PendingERP from '../views/PendingERP.vue'
import Releases from '../views/Releases.vue'
import Catalogs from '../views/Catalogs.vue'
import Booking from '../views/Booking.vue'
import CatalogProduct from '../views/CatalogProducts.vue'
import FinalScreenCheckout from '../views/FinalScreenCheckout.vue'
import Payment from '../views/Payment.vue'
import RecoverPassword from '../views/RecoverPassword.vue'
import Financiamento from '../views/Financiamento.vue'
import ManagementPartner from '../views/ManagementPartner.vue'
import PaymentLink from '../views/PaymentLink.vue'
import Banners from '../views/Banners.vue'
import LoginConfigs from '../views/LoginConfigs.vue'
import KitsMaintenance from '../views/KitsMaintenance.vue'
import ItemsMaintenance from '../views/ItemsMaintenance.vue'
import CentralDownloads from '../views/centralDownloads.vue'

import auth from "../../src/util/authPages";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/checkout/OrderFinished',
    name: 'FinalScreenCheckout',
    component: FinalScreenCheckout
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
  },
  {
    path: '/panel/orders/blockedDocuments',
    name: 'BlockedDocuments',
    component: BlockedDocuments
  },
  {
    path: '/panel/products',
    name: 'CatalogProduct',
    component: CatalogProduct
  },
	{
    path: '/panel/centralDownload',
    name: 'CentralDownloads',
    component: CentralDownloads
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: Checkout
  },
  {
    path: '/checkout/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/panel/dashboard',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/panel',
    name: 'Panel',
    component: Dashboard
  },
  {
    path: '/panel/campaigns',
    name: 'Campaigns',
    component: Campaigns
  },
  {
    path: '/account/orders',
    name: 'Orders',
    component: Orders
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/details',
    name: 'Details',
    component: Details
  },
  {
    path: '/account/orders/orderDetails',
    name: 'OrderDetails',
    component: OrderDetails
  },
  {
    path: '/account/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/account/cards',
    name: 'Cards',
    component: Cards
  },
  {
    path: '/CallCenter',
    name: 'CallCenter',
    component: CallCenter
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/sales/MySales',
    name: 'MySales',
    component: MySales
  },
  {
    path: '/panel/orders/DetailsOrder',
    name: 'DetailsOrder',
    component: DetailsOrder
  },
  {
    path: '/panel/register',
    name: 'RegisterClient',
    component: RegisterClient
  },
  {
    path: '/panel/Historic',
    name: 'HistoricClient',
    component: HistoricClient
  },
  {
    path: '/panel/orders',
    name: 'OrdersOMS',
    component: OrdersOMS
  },
  {
    path: '/panel/orders/OrderPrint',
    name: 'OrderPrint',
    component: OrderPrint
  },
  {
    path: '/panel/profitz/MyProfitz',
    name: 'Profitz',
    component: Profitz
  },
  {
    path: '/panel/profitz/redemptions',
    name: 'Redemptions',
    component: Redemptions
  },
  {
    path: '/panel/profitz/redeem',
    name: 'Redeem',
    component: Redeem
  },
  {
    path: '/panel/PendingBudgets',
    name: 'PendingBudgets',
    component: PendingBudgets
  },
  {
    path: '/panel/PendingOrder',
    name: 'PendingOrder',
    component: PendingOrder
  },
  {
    path: '/panel/PendingPayment',
    name: 'PendingPayment',
    component: PendingPayment
  },
  {
    path: '/panel/PendingRisk',
    name: 'PendingRisk',
    component: PendingRisk
  },
  {
    path: '/panel/PartialOrder',
    name: 'PartialOrder',
    component: PartialOrder
  },
  {
    path: '/panel/PendingERP',
    name: 'PendingERP',
    component: PendingERP
  },
  {
    path: '/releases',
    name: 'Releases',
    component: Releases
  },
  {
    path: '/panel/catalogs',
    name: 'Catalogs',
    component: Catalogs
  },
  {
    path: '/panel/booking',
    name: 'Booking',
    component: Booking
  },
  {
    path: '/recoverPassword',
    name: 'RecoverPassword',
    component: RecoverPassword
  },
  {
    path: '/Financiamento',
    name: 'Financiamento',
    component: Financiamento
  },
  {
    path: '/panel/ManagementPartner',
    name: 'ManagementPartner',
    component: ManagementPartner
  },
  {
    path: '/paymentLink',
    name: 'PaymentLink',
    component: PaymentLink
  },
]

if (auth.validaAcesso(['TI', 'GERENTE', 'MENU COMPLETO'])) {
  routes.push({
    path: '/panel/banners',
    name: 'Banners',
    component: Banners
  })

  routes.push({
    path: '/panel/loginConfigs',
    name: 'LoginConfigs',
    component: LoginConfigs
  })
}

if (auth.validaAcesso(['TI', 'EDITOR (SOLAR)'])) {
  routes.push({
    path: '/panel/KitsMaintenance',
    name: 'KitsMaintenance',
    component: KitsMaintenance
  })

  routes.push({
    path: '/panel/ItemsMaintenance',
    name: 'ItemsMaintenance',
    component: ItemsMaintenance
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
